import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation GenerateVideoMutation($input: GenerateVideoInput!) {
    generateVideo(input: $input) {
      url
    }
  }
`;

function commit(environment, eventId, startnumber, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        eventId,
        startnumber,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.generateVideo.url);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
